/**
 * Badge Variants
 *
 * CVA variants for the Badge component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see Badge.tsx for component implementation
 */

import {cva} from 'class-variance-authority';

export const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/90",
        primary: "border-transparent bg-primary text-primary-foreground hover:bg-primary/90",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        accent: "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
        muted: "border-transparent bg-muted text-muted-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "bg-transparent border-input text-foreground hover:bg-muted/50",
      },
      size: {
        xs: "h-5 text-micro px-2",
        sm: "h-6 text-[11px] px-2.5",
        md: "h-7 text-xs px-3",
      },
      interactive: {
        true: "cursor-pointer",
        false: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  }
);
